module.exports = __webpack_public_path__ + "img/barka.348820ec.webp";